"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginCopy = void 0;
const onboardingHeroCopy_1 = require("./onboardingHeroCopy");
exports.loginCopy = {
    header: 'Login to Malomo',
    input1: 'Email Address',
    input2: 'Password',
    cta: 'Log in',
    linkPreface: 'Want an account?',
    linkPrompt: 'Contact Us.',
    linkHref: 'mailto:help@gomalomo.com?subject=Help%20me%20create%20an%20account',
    heroHeader: onboardingHeroCopy_1.onboardingHeroCopy.header,
    heroSubHeader: onboardingHeroCopy_1.onboardingHeroCopy.subHeader,
    modalHeader: 'Choose an Account',
    forgotPassword: 'Forgot your password?',
    forgotPasswordHref: '/password_recovery',
    errorTitle: 'Login Error'
};
